// extracted by mini-css-extract-plugin
export var borderRadius = "_ft-4";
export var large = "_ft-3";
export var logoContainer = "_ft-0";
export var nameLogo = "_ft-2";
export var small = "_ft-1";